/* Dreambound product page behaviour.
   One file for the whole page: reveal-on-scroll, the feature tabs, the "show
   more reviews" toggle, and the buttons that scroll back to the buy block.
   Everything is delegated or observed, so sections can be reordered or removed
   in the theme editor without breaking anything. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal on scroll ---------------------------------------------- */
  function observeReveals() {
    var targets = document.querySelectorAll('.db-reveal:not([data-db-seen]),.db-stagger:not([data-db-seen])');
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-in');
        el.setAttribute('data-db-seen', '');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    targets.forEach(function (el) {
      el.setAttribute('data-db-seen', '');
      io.observe(el);
    });
  }

  /* ---- feature tabs --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-db-tab]');
    if (!btn) return;
    var root = btn.closest('[data-db-tabs]');
    if (!root) return;
    var i = btn.getAttribute('data-db-tab');
    root.querySelectorAll('[data-db-tab]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
    root.querySelectorAll('[data-db-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-db-panel') === i);
    });
  });

  /* ---- show the rest of the reviews ----------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-db-more]');
    if (!btn) return;
    var grid = document.getElementById(btn.getAttribute('data-db-more'));
    if (!grid) return;
    grid.querySelectorAll('[hidden]').forEach(function (c) { c.hidden = false; });
    btn.remove();
  });

  /* ---- scroll to the buy block, or to the sign-up form -----------------
     Both in-page calls to action used to jump to a hard-coded fraction of the
     document height, which drifted every time a section was added. These find
     their target instead. `data-db-scroll="perks"` aims at the footer sign-up
     form, because that is where the five perks are actually claimed — sending
     someone to Add to cart for them would be a dead end. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-db-scroll]');
    if (!btn) return;

    var target;
    if (btn.getAttribute('data-db-scroll') === 'perks') {
      target = document.querySelector('[id*="newsletter"] form, [id*="newsletter"]');
    }
    if (!target) {
      target = document.querySelector('.product-form__buttons')
            || document.querySelector('.product__info-container')
            || document.querySelector('.product');
    }
    if (!target) return;
    e.preventDefault();
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - 90,
      behavior: reduced ? 'auto' : 'smooth'
    });
  });

  /* One answer open at a time. Modern browsers do this themselves from the
     shared name="db-faq", so only stand in for the ones that don't -- otherwise
     both would fight over the same click. */
  if (!('name' in document.createElement('details'))) {
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.open || !d.matches || !d.matches('details[name="db-faq"]')) return;
      var siblings = document.querySelectorAll('details[name="db-faq"]');
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] !== d) siblings[i].open = false;
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeReveals);
  } else {
    observeReveals();
  }
  /* Sections render one after another, and the theme editor re-renders them on
     edit, so pick up anything that appears after this ran. */
  document.addEventListener('shopify:section:load', observeReveals);
  window.addEventListener('load', observeReveals);
})();
